export default __webpack_public_path__ + "static/media/cat.50dd0325.png";